import { Component, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TargetIntervalsComponent } from '@app/new-ui/manage/target-intervals/target-intervals.component';
import { WebClient } from '@injectables';
import { Device } from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Component({
    selector: 'dialog-target-interval-setting',
    templateUrl: './dialog-target-interval-setting.component.html',
    styleUrls: ['./dialog-target-interval-setting.component.scss']
})
export class DialogTargetIntervalSettingComponent {
    public constructor(
        private readonly host: MatDialogRef<DialogTargetIntervalSettingComponent, boolean>,
        private fragQuery: FragQueryService,
        private readonly webClient: WebClient
    ) { }

    private _targetIntervalsComponent: TargetIntervalsComponent;
    @ViewChild(TargetIntervalsComponent)
    set targetIntervalsComponent(component: TargetIntervalsComponent) {
        this._targetIntervalsComponent = component;
        if (component) {
            component.enableSaving = true;
        }
    }
    get targetIntervalsComponent(): TargetIntervalsComponent { return this._targetIntervalsComponent; }
    
    public visibleDeviceDropDown = true
    public readonly device$ = this.fragQuery.device$;

    public saveDevice = async (device: Device) => {
        return this.webClient.model.device.save(device);
    }

    public cancel() {
        this.host.close(false);
    }

    public saveSetting() {
        if (this.targetIntervalsComponent) {
            this.targetIntervalsComponent.saveSettings();
        }
        this.fragQuery.trigger$.next()
        this.host.close(true);
    }
}
